<template>
    <div v-html="CurrentReportHtml"></div>
</template>

<script>

import { mapState } from "vuex";

export default {
    name: 'ReportLoader',
    props: {
        ReportAction: String,
        ReportPath: String,
        StartOnMount: Boolean,
        CleanOnDestroy: Boolean
    },
    computed: {
        ...mapState({
            ReportHtml: state => state.reportLoader.Report
        }),
        CurrentReportHtml () {
            return this.ReportHtml[this.ReportAction]
        }
    },
    data () {
        return { }
    },
    async mounted () {
        if (this.StartOnMount) {
            await this.$store.dispatch('reportLoader/loadReport', {
                Id: this.ReportAction,
                Path: this.ReportPath
            });

            this.$emit('ReportLoaded')
        }        
    },
    beforeDestroy () {        
        this.$store.dispatch('reportLoader/CleanReport', {
            Id: this.ReportAction
        })
    }
}
</script>

